
import SocialProfilesView from './profiles/SocialProfilesView';
import { SocialProfilesProps } from './profiles/types';
import { ThemeProvider } from '@/components/theme-provider';

const SocialProfiles = (props: SocialProfilesProps) => {
  return (
    <ThemeProvider>
      <div className="h-full w-full overflow-hidden font-sans">
        <SocialProfilesView {...props} />
      </div>
    </ThemeProvider>
  );
};

export default SocialProfiles;
